module.exports = __webpack_public_path__ + "static/img/Slice 38.fad9bb03.png";